@if (isOpen()) {
  <!-- role="dialog", not alertdialog: it is not urgent and must not steal focus
       from someone part-way through a booking. -->
  <div
    class="cookie-banner"
    role="dialog"
    aria-modal="false"
    aria-labelledby="cookie-banner-title"
  >
    <div class="cookie-banner__inner">
      <div class="cookie-banner__body">
        <!-- Not a heading: the banner renders on every page. aria-labelledby
             still names the dialog from this id. -->
        <p class="cookie-banner__title" id="cookie-banner-title">Cookies on SnapSend</p>
        <p class="cookie-banner__text">
          We use a few essential cookies to keep you signed in. We'd also like to set analytics
          cookies to understand how the site is used, but only if you agree. You can change your
          mind at any time on our
          <a routerLink="/cookies">cookie policy</a> page.
        </p>
      </div>

      <div class="cookie-banner__actions">
        <button type="button" class="cookie-banner__btn cookie-banner__btn--ghost" (click)="reject()">
          Reject analytics
        </button>
        <button type="button" class="cookie-banner__btn" (click)="accept()">Accept all</button>
      </div>
    </div>
  </div>
}
